import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { SearchState } from '../../../core/search/search-state';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from '../../../core/search/search.service';
import { syncControlsWithQueryParams } from '../../../utils/router/sync-controls-with-query-params';
import { syncQueryParamsWithControls } from '../../../utils/router/sync-query-params-with-controls';
import { PersonDto } from '../../../core/dto/person';
import { MetadataService } from '../../../core/services/metadata.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'isav-people-search-page',
    templateUrl: './people-search-page.html',
    styleUrls: ['./people-search-page.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PeopleSearchPage implements OnInit {
    filters = new UntypedFormGroup({
        text: new UntypedFormControl(null),
        expertises: new UntypedFormControl(null),
    });

    searchState: Observable<SearchState<PersonDto>>;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private searchService: SearchService<PersonDto>,
        private metaService: MetadataService
    ) {}

    get apiParams(): { extractedText: string; 'expertises.id[]': string } {
        return {
            extractedText: this.filters.value.text,
            'expertises.id[]': this.filters.value.expertises,
        };
    }

    ngOnInit() {
        this.searchState = this.searchService.searchState();

        this.route.queryParams.pipe(untilDestroyed(this)).subscribe((queryParams) => {
            syncControlsWithQueryParams(this.filters, queryParams);
        });

        this.searchService.updateQuery(this.apiParams);
        this.searchService.sort('fullName', 'asc');
        this.metaService.setTitle('Search People');
    }

    resetFilters(): void {
        this.filters.reset({
            text: null,
            expertises: null,
        });
    }

    search() {
        syncQueryParamsWithControls(this.filters, this.router, this.route);
        this.searchService.search({
            ...this.apiParams,
            page: '1',
        });
    }
}
